import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { overviewFacts, overviewParagraphs } from "@/mocks/home";

export default function Overview() {
  return (
    <section id="overview" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="作品速览"
            title="这是一部怎样的作品"
            desc="在展开角色与剧情之前，先用最短的篇幅把这部作品的基本信息与故事起点说清楚，方便新观众快速建立框架。"
          />
        </Reveal>

        <div className="mt-10 grid gap-8 lg:grid-cols-12 lg:gap-10">
          <Reveal className="lg:col-span-7">
            <div className="space-y-4">
              {overviewParagraphs.map((text, index) => (
                <p key={`overview-p-${index}`} className="text-sm leading-8 text-foreground-700 md:text-base md:leading-8">
                  {text}
                </p>
              ))}
            </div>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <i className="ri-information-line text-primary-600" />
                基础档案
              </h3>
              <dl className="mt-5 divide-y divide-background-200">
                {overviewFacts.map((fact) => (
                  <div key={fact.id} className="flex flex-col gap-1 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
                    <dt className="text-xs text-foreground-500 md:text-sm">{fact.term}</dt>
                    <dd className="text-sm font-medium text-foreground-900 sm:text-right">{fact.detail}</dd>
                  </div>
                ))}
              </dl>
              <p className="mt-5 rounded-md bg-primary-100 px-4 py-3 text-xs leading-6 text-primary-900">
                提示：动画与漫画的覆盖范围不同，关于结局的疑问多半来自这一差异，后文会专门说明。
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}